import { CheckCircleIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  path: string;
};

const ThankYou: React.FC<Props> = ({ path }) => {
  return (
    <div className="flex flex-col items-center text-center py-16">
      <div
        className="flex h-16 w-16 items-center justify-center rounded-2xl text-white mb-5"
        style={{ backgroundColor: 'var(--primary-color)' }}
      >
        <CheckCircleIcon className="h-8 w-8" />
      </div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
        Appointment scheduled!
      </h1>
      <p className="mt-3 text-sm text-gray-400 dark:text-gray-500 max-w-sm">
        We look forward to seeing you at your next appointment. You can view and manage all your
        appointments below.
      </p>
      <Link
        to={`/${path}/appointments`}
        className="mt-8 inline-flex items-center rounded-xl px-6 py-3 text-sm font-semibold text-white transition-opacity active:opacity-80"
        style={{ backgroundColor: 'var(--primary-color)' }}
      >
        View appointments
      </Link>
    </div>
  );
};

export default ThankYou;
